export default __webpack_public_path__ + "static/media/matthew-tenbruggencate-oZVbsRE99rg-unsplash.b0c44ba4.jpg";